import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { QuestionI, ServerObjResponse } from '@models';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminSettingService {
  private questionURL = environment.ADMIN.QUESTION;

  constructor(private readonly http: HttpClient) {}

  public getQuestion(): Observable<ServerObjResponse> {
    return this.http.get<ServerObjResponse>(this.questionURL);
  }

  public getQuestionLog(
    pageNumber: number,
    pageSize: number
  ): Observable<ServerObjResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.set('pageNumber', `${pageNumber}`);
    queryParams = queryParams.set('pageSize', `${pageSize}`);

    return this.http.get<ServerObjResponse>(`${this.questionURL}/log`, {
      params: queryParams,
    });
  }

  public publish(params: QuestionI): Observable<ServerObjResponse> {
    return this.http.put<ServerObjResponse>(this.questionURL, params);
  }
}
